export default __webpack_public_path__ + "static/media/people1.f3fd89b3.png";